/**
 * Open-redirect protection for `?next=` parameters (login, OAuth). Only same-origin **relative**
 * paths survive; anything else falls back. API paths are never valid post-login destinations.
 */
const PLACEHOLDER_ORIGIN = 'http://redirect-check.invalid';

export function safeRedirectPath(next: unknown, fallback = '/'): string {
  if (typeof next !== 'string') return fallback;
  const value = next.trim();
  if (value === '' || value.length > 2048) return fallback;
  // eslint-disable-next-line no-control-regex -- rejecting control characters is the point
  if (/[\u0000-\u001f\u007f\\]/.test(value)) return fallback;
  if (!value.startsWith('/') || value.startsWith('//')) return fallback;

  let url: URL;
  try {
    url = new URL(value, PLACEHOLDER_ORIGIN);
  } catch {
    return fallback;
  }
  if (url.origin !== PLACEHOLDER_ORIGIN) return fallback;
  if (url.pathname === '/api' || url.pathname.startsWith('/api/')) return fallback;
  return `${url.pathname}${url.search}${url.hash}`;
}
